export default "__VITE_ASSET__Bzz7xFrW__"